/** TransferState keys for SSR/prerender → browser hydration (runbook P2). */
export const TRANSFER_STATE_KEYS = {
  POPULAR_DRUGS: 'popularDrugs',
  FAQ_DATA: 'faqData',
} as const;
